module.exports = __webpack_public_path__ + "static/media/penalty.7560e027.svg";